import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useTournamentStateContext } from "../data/providers/TournamentStateProvider";
import { notify } from "../utils/notify";

export const RedirectToRecentTournament = () => {
  const navigate = useNavigate();
  const { getMostRecentLiveTournament } = useTournamentStateContext();

  useEffect(() => {
    (async () => {
      try {
        const tournament = await getMostRecentLiveTournament();
        navigate(`/tournaments/${tournament.id}/${tournament.slug}`);
      } catch (error) {
        // axios errors already print to the console and alert the user of error
        if (!axios.isAxiosError(error)) {
          console.error("Error fetching tournament:", error);
          notify.error("There was an error fetching data.");
        }
      }
    })();
  }, [navigate]);

  return <div>Loading...</div>;
};
